export const buildUrl = (slug, page) => {
  let url = '/';

  if (page) {
    if (page.treeParent) {
      if (page.treeParent.treeParent && page.treeParent.treeParent.treeParent) {
        url += `${page.treeParent.treeParent.treeParent.slug}/`;
      }

      if (page.treeParent.treeParent) {
        url += `${page.treeParent.treeParent.slug}/`;
      }

      url += `${page.treeParent.slug}/`;
    } else if (page.internal && page.internal.type) {
      if (page.internal.type === 'DatoCmsBlog') {
        url += `${page.categories[0].slug}/`;
      } else if (page.internal.type === 'DatoCmsBlogCategory') {
        url += 'category/';
      } else if (page.internal.type === 'DatoCmsBlogAuthor') {
        url += 'author/';
      } else if (page.internal.type === 'DatoCmsCaseStudy') {
        url += 'salesforce-case-studies/';
      } else if (page.internal.type === 'DatoCmsWebinar') {
        url += 'webinars/';
      } else if (page.internal.type === 'DatoCmsSalesforceExplainer') {
        url += 'salesforce-products-explained/';
      }
    }
  }

  url += `${slug !== '/' ? `${slug.replace(/^\/|\/$/g, '')}/` : ''}`;

  return url;
};
